module.exports = __webpack_public_path__ + "static/AboutUs-Mission-Graphics_v1-2a408894cd357862e6516f69df363a0d.svg";